import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AuthGuard } from '@projects/adir/src/app/guards/auth.guard';
import { PrivateLayoutComponent } from '@projects/adir/src/app/layouts/private-layout/private-layout.component';
import { PublicLayoutComponent } from '@projects/adir/src/app/layouts/public-layout/public-layout.component';
import { AdirDetailsLayoutComponent } from '@projects/adir/src/app/pages/adir-details/layout/adir-details-layout.component';
import { FdpDetailsLayoutComponent } from '@projects/adir/src/app/pages/fdp-details/fdp-details-layout/fdp-details-layout.component';
import { RoleGuard } from './guards/role.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: PublicLayoutComponent,
    canActivate: [!AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@projects/adir/src/app/pages/login/login.component').then((m) => {
            return m.LoginComponent;
          }),
      },
      {
        path: '**',
        redirectTo: 'login',
      },
    ],
  },
  {
    path: '',
    pathMatch: 'prefix',
    component: PrivateLayoutComponent,
    canActivate: [MsalGuard, AuthGuard],
    children: [
      {
        path: 'historical-milestone-review',
        pathMatch: 'prefix',
        loadComponent: () =>
          import('@projects/adir/src/app/pages/historical-mr/historical-mr.component').then((m) => {
            return m.HistoricalMrComponent;
          }),
      },
      {
        path: 'action-items-tracker/:requestID/:reviewId',
        canActivate: [RoleGuard],
        loadComponent: () =>
          import('@projects/adir/src/app/pages/action-items-tracker/action-items-tracker.component').then((m) => {
            return m.ActionItemsTrackerComponent;
          }),
      },
      {
        path: 'user-management',
        canActivate: [RoleGuard],
        loadComponent: () =>
          import('@projects/adir/src/app/pages/user-management/user-management.component').then((m) => {
            return m.UserManagementComponent;
          }),
      },
      {
        path: 'settings',
        canActivate: [RoleGuard],
        loadComponent: () =>
          import('@projects/adir/src/app/pages/settings/settings.component').then((m) => {
            return m.SettingsComponent;
          }),
      },
      {
        path: 'adir',
        pathMatch: 'prefix',
        canActivate: [RoleGuard],
        loadComponent: () =>
          import('@projects/adir/src/app/pages/adir-summary/adir-summary.component').then((m) => {
            return m.AdirSummaryComponent;
          }),
      },
      {
        path: 'adir/:ID/:reviewId',
        pathMatch: 'prefix',
        canActivate: [RoleGuard],
        component: AdirDetailsLayoutComponent,
        children: [
          {
            path: 'milestone-reviews',
            loadComponent: () =>
              import(
                '@projects/adir/src/app/pages/adir-details/milestone-review-request-form/milestone-review-request-form.component'
              ).then((m) => {
                return m.MilestoneReviewRequestFormComponent;
              }),
          },
          {
            path: 'minutes-of-meeting',
            pathMatch: 'prefix',
            loadComponent: () => {
              return import(
                '@projects/adir/src/app/pages/adir-details/minutes-of-meeting/minutes-of-meeting.component'
              ).then((m) => {
                return m.MinutesOfMeetingComponent;
              });
            },
          },
          {
            path: 'attachments',
            loadComponent: () =>
              import('@projects/adir/src/app/pages/adir-details/attachments/attachments.component').then((m) => {
                return m.AttachmentsComponent;
              }),
          },
          {
            path: 'activity-logs',
            loadComponent: () =>
              import('@projects/adir/src/app/pages/adir-details/activity-logs/activity-logs.component').then((m) => {
                return m.AdirActivityLogsComponent;
              }),
          },
          {
            path: '**',
            redirectTo: 'milestone-reviews',
          },
        ],
      },
      {
        path: 'fdp',
        pathMatch: 'prefix',
        canActivate: [RoleGuard],
        loadComponent: () =>
          import('@projects/adir/src/app/pages/fdp-summary/fdp-summary.component').then((m) => {
            return m.FdpSummaryComponent;
          }),
      },
      {
        path: 'fdp/:requestId',
        pathMatch: 'prefix',
        canActivate: [RoleGuard],
        component: FdpDetailsLayoutComponent,
        children: [
          {
            path: 'submission',
            loadComponent: () =>
              import('@projects/adir/src/app/pages/fdp-details/fdp-submission/fdp-submission.component').then((m) => {
                return m.FdpSubmissionComponent;
              }),
          },
          {
            path: 'reviewer-nomination',
            loadComponent: () =>
              import(
                '@projects/adir/src/app/pages/fdp-details/reviewer-nomination-form/reviewer-nomination-form.component'
              ).then((m) => {
                return m.ReviewerNominationFormComponent;
              }),
          },
          {
            path: 'position-paper',
            loadComponent: () =>
              import('@projects/adir/src/app/pages/fdp-details/position-paper/position-paper.component').then((m) => {
                return m.PositionPaperComponent;
              }),
          },
          {
            path: 'progress-review',
            loadComponent: () =>
              import('@projects/adir/src/app/pages/fdp-details/progress-review/progress-review.component').then((m) => {
                return m.ProgressReviewComponent;
              }),
          },
          {
            path: 'progress-review-approval',
            loadComponent: () =>
              import(
                '@projects/adir/src/app/pages/fdp-details/progress-review-approval/progress-review-approval.component'
              ).then((m) => {
                return m.ProgressReviewApprovalComponent;
              }),
          },
          {
            path: 'attachments',
            loadComponent: () =>
              import('@projects/adir/src/app/pages/fdp-details/attachments-section/attachments-section.component').then(
                (m) => {
                  return m.FpdAttachmentsSectionComponent;
                }
              ),
          },
          {
            path: 'activity-logs',
            loadComponent: () =>
              import('@projects/adir/src/app/pages/fdp-details/activity-logs/activity-logs.component').then((m) => {
                return m.FdpActivityLogsComponent;
              }),
          },
          {
            path: '**',
            redirectTo: 'submission',
          },
        ],
      },
      {
        path: '**',
        redirectTo: 'adir',
      },
    ],
  },
];
